<template>
  <v-app id="inspire">
    <template v-if="!$route.meta.allowAnonymous">
        <v-content>
          <router-view></router-view>
        </v-content>
    </template>
    <template v-else>
      <navigation :toggle="drawer"/>
      <toolbar @toggleNavigationBar="drawer = !drawer"/>
      <v-content>
        <breadcrumbs />
          <router-view/>
      </v-content>
        <v-footer color="#1976D2" app >
          <span class="white--text">&copy; {{ year() }}</span>
        </v-footer>
    </template>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    drawer: false
  }),
  methods: {
    year () {
      const year = new Date().toISOString().substr(0, 4)
      return year
    }
  }
}
// iisexpress-proxy 3000 to 3024
</script>
